import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function PublisherMenu({ activeItem }) {
  return (
    <li className="nav-item">
      <Link
        to="/publisher/all"
        className={`nav-link  d-flex
        ${sidebarHelper.checkActiveItem(activeItem, "all-publisher")} `}
      >
        {/* <i className="nav-icon hl-panel"></i> */}
        <i class="fa-solid fa-table-columns pl-2"></i>
        <p>جایگاه های تبلیغاتی </p>
      </Link>
    </li>
  );
}
